/* eslint-disable */
"use strict";
if (sessionStorage.getItem('storeReloadInProgress') === '1') {
    window.__storeReloadScheduled = true;
    sessionStorage.setItem('storeReloadInProgress', '0');
} else {
    window.__storeReloadScheduled = false;
}

window.__storeReloadScheduled = sessionStorage.getItem('storeReloadInProgress') === '1';
function storeLocator() {
    return {
        googleAutocompleteService: null,
        googleDistanceService: null,

        isPopUpBlocked: false,
        isPopupVisible: false,
        isPopupPreviewStoreVisible: false,
        isPopupClearCartVisible: false,
        isStoreListVisible: false,
        isCartEmpty: true,

        errorLocator: {
            status: "error",
            message: "",
            isActive: false
        },

        query: "",
        predictions: [],
        predictionState: {},

        stores: [],
        selectedStore: {},
        savedStore: {},

        pdpLocationAvailability: [],

        map: {
            init: null,
            geocoder: null,
            markers: [],
            currentInfoWindow: null
        },

        messages: {},

        async init() {
            window.OD = window.OD || {};
            window.OD.store = window.OD.store || {};

            this.initMessage();

            const storesScriptJSON = document.getElementById("storesJSON");

            if (storesScriptJSON) {
                try {
                    const storesOBJ = JSON.parse(storesScriptJSON.textContent);
                    if (storesOBJ?.stores?.length > 0) {
                        this.stores = storesOBJ.stores;
                    }
                } catch (error) {
                    console.error("Error parsing stores JSON:", error);
                }
            }

            this.googleAutocompleteService =
                new google.maps.places.AutocompleteService();
            this.googleDistanceService =
                new google.maps.DistanceMatrixService();

            const isSelectedStore = localStorage.getItem("selectedStore");
            const parsedStore = JSON.parse(isSelectedStore);

            if (parsedStore?.id) {
                this.setSavedStore(parsedStore.id);
                this.visiblePopupLocator(false);
            } else {
                this.visiblePopupLocator(true);
            }

            this.checkStoreInUrl();
            setTimeout(() => {
                this.initStoreOnSearchORCollection();
            }, 1000);

            await this.fetchCart();

            this.hideStoreInURL(["filter.p.m.store.location_availability"]);

            this.initStoreOnPDP();

            this.$watch("savedStore", (newSavedStore) => {
                this.$dispatch("store-changed", {
                    storeId: newSavedStore.id,
                    storeTitle: newSavedStore.location_title
                });
            });

            this.initStoreMap();
        },

        initMessage() {
            this.messages = window.OD.customizer.messages || {};
        },

        initSaleCollectionLink() {
            const links = document.querySelectorAll(
                '[href="#sale-store"], [data-sale-collection]'
            );
            if (!links && !this.savedStore.sale_collection_url) return;

            links.forEach((link) => {
                link.setAttribute("data-sale-collection", "");
                link.setAttribute(
                    "href",
                    this.savedStore.sale_collection_url
                        ? this.savedStore.sale_collection_url
                        : "#sale-store"
                );
            });
        },

        initStoreMap() {
            if (document.querySelector("#map")) {
                this.triggerStoresMap();
                document.addEventListener("click", (event) => {
                    const storeListItem =
                        event.target.closest(".store-list__item");
                    const mapContainer = document.getElementById("map");

                    const addressEl = event.target
                        .closest(".store-item-group")
                        ?.querySelector(".store-item__address");
                    const address = addressEl?.textContent.trim();

                    if (address) {
                        this.resetMap(address);
                    }

                    if (
                        !storeListItem &&
                        !mapContainer.contains(event.target)
                    ) {
                        this.resetMap();

                        if (this.map.currentInfoWindow) {
                            this.map.currentInfoWindow.close();
                            this.map.currentInfoWindow = null;
                        }
                    }
                });
            }
        },

        async triggerStoresMap() {
            const loadGoogleMaps = () => {
                return new Promise((resolve) => {
                    const checkGoogle = () => {
                        if (window.google) {
                            resolve();
                        } else {
                            setTimeout(checkGoogle, 100);
                        }
                    };
                    checkGoogle();
                });
            };

            await loadGoogleMaps();

            const mapContainer = document.getElementById("map");
            if (!mapContainer) return;

            const isSingleStoreMode =
                mapContainer.hasAttribute("data-store-info");

            let targetStore = null;

            if (isSingleStoreMode) {
                const pathParts = window.location.pathname.split("/");
                const storeSlug = pathParts[pathParts.length - 1];

                targetStore = this.stores.find(
                    (store) =>
                        store.store_handle?.toLowerCase() ===
                        storeSlug.toLowerCase()
                );

                if (!targetStore) {
                    return;
                }
            }

            this.map.init = new google.maps.Map(
                document.getElementById("map"),
                {
                    center: { lat: -25.274398, lng: 133.775136 },
                    zoom: isSingleStoreMode ? 12 : 4
                }
            );

            this.map.geocoder = new google.maps.Geocoder();

            const storesToRender = isSingleStoreMode
                ? [targetStore]
                : this.stores.filter(
                      (store) => store.location_address && store.isVisible
                  );
            for (const store of storesToRender) {
                const { location_address, location_title, url } = store;

                this.map.geocoder.geocode(
                    { address: location_address },
                    (results, status) => {
                        if (status === "OK") {
                            const position = results[0].geometry.location;

                            const marker = new google.maps.Marker({
                                position,
                                map: this.map.init,
                                title: location_title,
                                icon: {
                                    url: "data:image/svg+xml,%3Csvg%20width%3D%2236%22%20height%3D%2244%22%20viewBox%3D%220%200%2036%2044%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20filter%3D%22url(%23filter0_d_4777_17364)%22%3E%3Crect%20width%3D%2236%22%20height%3D%2236%22%20rx%3D%2218%22%20fill%3D%22black%22%2F%3E%3Cpath%20d%3D%22M24.3402%2018.7381C25.9664%2017.0471%2026.4973%2014.3832%2025.5968%2012.283C24.5485%209.81365%2022.6737%208.44478%2020.026%208.35084C19.9588%208.35084%2019.8849%208.35084%2019.811%208.34413H12.083C12.7886%209.21645%2013.4942%2010.0888%2014.1998%2010.9611H19.7438C19.858%2010.9611%2019.9655%2010.9611%2020.0663%2010.9611C22.1562%2011.0013%2023.7287%2013.0345%2023.3255%2015.1079C23.0029%2016.7385%2021.9277%2017.6846%2019.9655%2018.0134H19.9386L27.5188%2027.3941C27.6532%2027.5619%2027.8548%2027.6558%2028.0698%2027.6558H30.9728C28.6007%2024.7168%2026.3293%2021.8986%2023.9975%2019.0132C24.1252%2018.9126%2024.2529%2018.832%2024.3537%2018.7314%22%20fill%3D%22%2300BFB3%22%2F%3E%3Cpath%20d%3D%22M13.219%2020.6505H16.1287L8.2798%2010.9678H5.02734L12.6478%2020.3686C12.7822%2020.5364%2012.9972%2020.6505%2013.2123%2020.6505%22%20fill%3D%22%23CDDF16%22%2F%3E%3Cpath%20d%3D%22M21.1214%2024.7571H24.0312L16.189%2015.0744H12.9365L20.557%2024.4753C20.6914%2024.643%2020.9064%2024.7571%2021.1214%2024.7571Z%22%20fill%3D%22%2378D64B%22%2F%3E%3Cpath%20d%3D%22M18%2044L4.14359%2029L31.8564%2029L18%2044Z%22%20fill%3D%22black%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3Cfilter%20id%3D%22filter0_d_4777_17364%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2244%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%20result%3D%22hardAlpha%22%2F%3E%3CfeOffset%2F%3E%3CfeComposite%20in2%3D%22hardAlpha%22%20operator%3D%22out%22%2F%3E%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%220%200%200%200%201%200%200%200%200%200%200%200%200%200%200%200%200%200%201%200%22%2F%3E%3CfeBlend%20mode%3D%22normal%22%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow_4777_17364%22%2F%3E%3CfeBlend%20mode%3D%22normal%22%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow_4777_17364%22%20result%3D%22shape%22%2F%3E%3C%2Ffilter%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                }
                            });

                            if (isSingleStoreMode) {
                                this.map.init.setCenter(position);
                                this.map.init.setZoom(15);
                            }

                            const infoWindow = new google.maps.InfoWindow({
                                content: `
                                    <div class="map-popup__wrapper">
                                      
                                        <h3 class="map-popup__title">${location_title}</h3>
                                        <div class="actions">
                                            <a href="${this.savedStore.url}" target="_blank" class="button">Your store</a>
                                            <a href="${url}" class="button button--secondary" target="_blank">VIEW store details</a>
                                        </div>
                                    </div>
                                `
                            });

                            marker.addListener("click", () => {
                                if (this.map.currentInfoWindow) {
                                    this.map.currentInfoWindow.close();
                                }

                                infoWindow.open({
                                    anchor: marker,
                                    map
                                });

                                this.map.currentInfoWindow = infoWindow;
                            });
                        } else {
                            console.error(
                                `Geocode failed for address "${location_address}" because: ${status}`
                            );
                        }
                    }
                );
            }
            if (!isSingleStoreMode) {
                this.resetMap();
            }
        },

        resetMap(address) {
            const storesToRender = this.stores.filter(
                (store) => store.location_address && store.isVisible && store.id !== this.savedStore.id
            );

            if (address) {
                const geocoder = new google.maps.Geocoder();

                geocoder.geocode({ address: address }, (results, status) => {
                    if (status === "OK") {
                        const position = results[0].geometry.location;
                        setTimeout(() => {
                            this.map.init.setZoom(15);
                            this.map.init.panTo(position);
                        }, 100);
                    } else {
                        console.error(
                            `Geocode failed for ${firstStore.location_address}: ${status}`
                        );
                        this.map.init.setZoom(4);
                        this.map.init.panTo({
                            lat: -25.274398,
                            lng: 133.775136
                        });
                    }
                });
            }

            if (
                storesToRender.length <= this.stores.length &&
                storesToRender.length > 0
            ) {
                const firstStore = storesToRender[0];
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode(
                    { address: firstStore.location_address },
                    (results, status) => {
                        if (status === "OK") {
                            const position = results[0].geometry.location;
                            this.map.init.setZoom(8);
                            this.map.init.panTo(position);
                        } else {
                            console.error(
                                `Geocode failed for ${firstStore.location_address}: ${status}`
                            );
                            this.map.init.setZoom(4);
                            this.map.init.panTo({
                                lat: -25.274398,
                                lng: 133.775136
                            });
                        }
                    }
                );
            } else {
                this.map.init.setZoom(4);
                this.map.init.panTo({ lat: -25.274398, lng: 133.775136 });
            }
        },

        panToMarker(store) {
            const markerObject = this.map.markers.find(
                (m) => m.store.id === store.id
            );
            if (markerObject) {
                this.map.init.panTo(markerObject.marker.getPosition());
                this.map.init.setZoom(14);
            }
        },

        blockedPopupLocator(isPopUpBlocked) {
            this.isPopUpBlocked = isPopUpBlocked;
        },

        visiblePopupLocator(isPopupVisible) {
            this.isPopupVisible = isPopupVisible;
            if (isPopupVisible) {
                document.body.classList.add("overflow-hidden");
            } else {
                document.body.classList.remove("overflow-hidden");
                window.scrollTo(0, 0);
            }
        },

        visiblePopupPreviewStore(isPopupPreviewStoreVisible) {
            this.isPopupPreviewStoreVisible = isPopupPreviewStoreVisible;
        },

        visiblePopupClearCart(isPopupClearCartVisible) {
            this.isPopupClearCartVisible = isPopupClearCartVisible;
        },

        visibleStoreList(isStoreListVisible) {
            this.isStoreListVisible = isStoreListVisible;

            if (isStoreListVisible) {
                const container = document.querySelector(
                    ".store-locator-popup .stores-list-group"
                );
                container && window.OD.checkScrollVisibility(container);
            }
        },

        clearErrorLocator() {
            this.errorLocator = {
                status: "error",
                message: "",
                isActive: false
            };
        },

        setErrorLocator(status, message) {
            this.errorLocator = {
                status,
                message,
                isActive: true
            };
        },

        goToPage(page) {
            window.location.href = page;
        },

        async fetchCart() {
            await new Promise((resolve) => {
                const event = new CustomEvent("cart:get", {
                    detail: { resolve: resolve }
                });
                window.dispatchEvent(event);
            }).then((cartData) => {
                cartData.item_count > 0
                    ? (this.isCartEmpty = false)
                    : (this.isCartEmpty = true);
                document.dispatchEvent(new Event("cart:refresh"));
            });
        },

        async clearCart() {
            await fetch("/cart/clear.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to clear the cart");
                    }
                    return response.json();
                })
                .then((data) => {
                    console.log("Cart cleared:", data);

                    localStorage.setItem(
                        "selectedStore",
                        JSON.stringify(this.selectedStore)
                    );
                    this.setSavedStore(this.selectedStore.id);
                    this.visiblePopupClearCart(false);

                    document.dispatchEvent(new Event("cart:get"));
                    document.dispatchEvent(new Event("cart:refresh"));

                    this.updateCartCount();
                })
                .catch((error) => {
                    console.error("Error:", error);
                    this.setErrorLocator("error", `Error: - "${error}"`);
                });
        },

        async updateCartCount() {
            try {
                let response = await fetch("/cart.js");
                if (!response.ok) {
                    throw new Error(
                        `Error ${response.status}: ${response.statusText}`
                    );
                }

                let cartData = await response.json();
                let cartCountElement = document.querySelector(
                    "cart-count.count-bubble"
                );

                if (cartCountElement) {
                    let countSpan = cartCountElement.querySelector(
                        "span[aria-hidden='true']"
                    );
                    if (countSpan) {
                        countSpan.textContent = cartData.item_count;
                    }

                    let srOnlySpan =
                        cartCountElement.querySelector("span.sr-only");
                    if (srOnlySpan) {
                        srOnlySpan.textContent = `${cartData.item_count} item${cartData.item_count !== 1 ? "s" : ""}`;
                    }
                }
            } catch (error) {
                console.error("Error updating cart count:", error);
            }
        },

        getUrlSearchParams() {
            return new URLSearchParams(window.location.search);
        },

        getSelectedStoreName() {
            return {
                default: window.OD.store.location_title,
                normalized: window.OD.store.location_title
                    ?.replace(/\bmy ride\b/i, "")
                    .trim()
                    .toLowerCase()
            };
        },

        triggerBlockedPDP(data) {
            const { message, hidePopUp = false, blockedPopUp = false } = data;

            message && this.setErrorLocator("error", message);
            hidePopUp && this.visiblePopupLocator(false);

            if (blockedPopUp) {
                this.visiblePopupLocator(true);
                this.blockedPopupLocator(true);
            }
        },

        initStoreOnSearchORCollection() {
            const path = window.location.pathname;
            const isSearchOrCollectionPage =
                path.includes("/search") || path.includes("/collections");

            if (!isSearchOrCollectionPage) return;

            const isSaleCollection =
                window.OD.collection?.isSale && path.includes("sale-");
            if (isSaleCollection) {
                const { sale_collection_url } = this.savedStore;
                console.log(sale_collection_url);
                if (sale_collection_url) {
                    if (sale_collection_url !== path) {
                        console.log(
                            "Redirect to Sale collection =>",
                            sale_collection_url
                        );

                        this.goToPage(sale_collection_url);
                        return;
                    }
                } else {
                    console.log("Sale collection not found. Redirect to home");
                    this.goToPage("/");
                    return;
                }
            }

            const urlParams = this.getUrlSearchParams();
            const isFilterParamMissing = !urlParams.has(
                "filter.p.m.store.location_availability"
            );

            if (
                isFilterParamMissing &&
                (path.includes("/search") ||
                    (path.includes("/collections") &&
                        !path.includes("/collections/all")))
            ) {
                this.addStoreFilterParam(path);
                console.log("add filter store param");
            }

            this.visiblePopupLocator(false);
        },

        initEmptyPDP(
            note = `It looks like this product does not belong to any store`
        ) {
            const containers = document.querySelectorAll(
                "product-rerender .empty-state, product-rerender .product-info"
            );

            if (containers) {
                const emptyStateHTML = `
                                <div class="empty-state" data-products-not-found>
                                    <div class="empty-state__icon-wrapper">
                                       <svg
                                            role="presentation"
                                            fill="none"
                                            focusable="false"
                                            stroke-width="2"
                                            width="32"
                                            height="32"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M11.715 21.43c5.365 0 9.715-4.35 9.715-9.715S17.08 2 11.715 2 2 6.35 2 11.715s4.35 9.715 9.715 9.715Z" fill="currentColor" fill-opacity=".12"/>
                                            <path d="M21.43 11.715c0 5.365-4.35 9.715-9.715 9.715a9.686 9.686 0 0 1-6.953-2.93A9.683 9.683 0 0 1 2 11.715C2 6.35 6.35 2 11.715 2A9.683 9.683 0 0 1 18.5 4.762a9.686 9.686 0 0 1 2.93 6.953Z" fill="currentColor" fill-opacity=".12"/>
                                            <path d="M18.5 4.762A9.683 9.683 0 0 0 11.715 2C6.35 2 2 6.35 2 11.715A9.683 9.683 0 0 0 4.762 18.5M18.5 4.762a9.686 9.686 0 0 1 2.93 6.953c0 5.365-4.35 9.715-9.715 9.715a9.686 9.686 0 0 1-6.953-2.93M18.5 4.762 4.762 18.5" stroke="currentColor"/>
                                        </svg>
                                        <span class="count-bubble count-bubble--lg">0</span>
                                    </div>
                                    <div class="prose">
                                        <p class="h5">
                                            ${note}
                                        </p>
                                    </div>
                                </div>
                            `;

                containers.forEach((container) => {
                    container.innerHTML = emptyStateHTML;
                });
            }
        },

        initStoreOnPDP() {
            const path = window.location.pathname;
            if (!path.includes("/products/")) return;

            const storesForProductJSON = document.getElementById(
                "storesForProductJSON"
            );
            if (!storesForProductJSON) {
                this.initEmptyPDP(
                    `It looks like this product does not belong to any store`
                );
                return;
            }

            try {
                this.pdpLocationAvailability = JSON.parse(
                    storesForProductJSON.textContent
                );
            } catch (error) {
                console.error("Error parsing stores JSON:", error);
                this.initEmptyPDP(
                    `An error occurred while trying to find the stores to which this product belongs. Please try again or contact support`
                );
                return;
            }

            if (
                !Array.isArray(this.pdpLocationAvailability) ||
                this.pdpLocationAvailability.length === 0
            ) {
                this.initEmptyPDP(
                    `It looks like this product does not belong to any store`
                );
                return;
            }

            const storeName = this.getSelectedStoreName();
            const normalizedStoreName = storeName.normalized;

            if (!normalizedStoreName) {
                this.triggerBlockedPDP({
                    message: `It looks like you haven't chosen a store yet. Please select your region and store`
                });
                return;
            }
        },

        async addStoreFilterParam(path) {
            const filterLocationInputs = document.querySelectorAll(
                "#accordion-filter-p-m-store-location_availability .checkbox-container input"
            );

            let filterFinded = false;

            if (filterLocationInputs.length > 0) {
                const storeName = this.getSelectedStoreName();
                const normalizedStoreName = storeName.normalized.toLowerCase();
                const defaultStoreName = storeName.default.toLowerCase();

                filterLocationInputs.forEach((input) => {
                    const inputValue = input.value.toLowerCase();
                    const isFilterInput =
                        inputValue == normalizedStoreName ||
                        inputValue == defaultStoreName;
                    if (isFilterInput) {
                        window.OD.store.location_filter = input.value.trim();
                        const label = input.nextElementSibling;
                        label.click();
                        filterFinded = true;
                        return;
                    }
                });
            }

            if (!filterFinded) {
                this.triggerProductNotFound(path);
            }
        },

        initEmptyCollection() {
            const container = document.querySelector(".od-collection-grid");

            if (container) {
                const emptyStateHTML = `
                    <div class="empty-state" data-products-not-found>
                        <div class="empty-state__icon-wrapper">
                           <svg
                                role="presentation"
                                fill="none"
                                focusable="false"
                                stroke-width="2"
                                width="32"
                                height="32"
                                viewBox="0 0 24 24"
                            >
                                <path d="M11.715 21.43c5.365 0 9.715-4.35 9.715-9.715S17.08 2 11.715 2 2 6.35 2 11.715s4.35 9.715 9.715 9.715Z" fill="currentColor" fill-opacity=".12"/>
                                <path d="M21.43 11.715c0 5.365-4.35 9.715-9.715 9.715a9.686 9.686 0 0 1-6.953-2.93A9.683 9.683 0 0 1 2 11.715C2 6.35 6.35 2 11.715 2A9.683 9.683 0 0 1 18.5 4.762a9.686 9.686 0 0 1 2.93 6.953Z" fill="currentColor" fill-opacity=".12"/>
                                <path d="M18.5 4.762A9.683 9.683 0 0 0 11.715 2C6.35 2 2 6.35 2 11.715A9.683 9.683 0 0 0 4.762 18.5M18.5 4.762a9.686 9.686 0 0 1 2.93 6.953c0 5.365-4.35 9.715-9.715 9.715a9.686 9.686 0 0 1-6.953-2.93M18.5 4.762 4.762 18.5" stroke="currentColor"/>
                            </svg>
                            <span class="count-bubble count-bubble--lg">0</span>
                        </div>
                        <div class="prose">
                            <p class="h4">
                                We did not find any products related to the store.
                            </p>
                        </div>
                    </div>
                `;

                container.innerHTML = emptyStateHTML;
            }
        },

        triggerProductNotFound(path) {
            const isProductNotFound = document.querySelector(
                "[data-products-not-found]"
            );

            if (isProductNotFound) {
                this.visiblePopupLocator(true);
                this.setErrorLocator(
                    "error",
                    `We did not find any products for the selected store - "${this.savedStore.location_title}". Please select another store`
                );
            } else {
                if (!Shopify.designMode) {
                    if (
                        path.includes("/collections") &&
                        !path.includes("/collections/all")
                    ) {
                        if (
                            window.OD.customizer.storeLocator.collection
                                .collection_behavior == "redirect"
                        ) {
                            this.goToPage("/");
                        } else {
                            this.initEmptyCollection();
                        }
                    } else {
                        this.goToPage("/");
                    }
                }
            }
        },

        hideStoreInURL(params) {
            if (!Array.isArray(params)) {
                console.error(
                    "Expected an array of parameter names to remove."
                );
                return;
            }

            const urlParams = this.getUrlSearchParams();

            params.forEach((param) => urlParams.delete(param));

            const newUrl = urlParams.toString()
                ? `${window.location.pathname}?${urlParams.toString()}`
                : window.location.pathname;

            window.history.replaceState({}, document.title, newUrl);
        },

        getCookie(name) {
            const matches = document.cookie.match(
                new RegExp(
                    "(?:^|; )" +
                        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
                        "=([^;]*)"
                )
            );
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },

        setCookie(name, value) {
            document.cookie = `${name}=${encodeURIComponent(value)}; path=/;`;
        },

        checkStoreInUrl() {
            const urlParams   = new URLSearchParams(location.search);
            const storeParam  = urlParams.get('store');
            const regionParam = urlParams.get('region_id');
            if (!storeParam && !regionParam) return;

            if (storeParam) {
                this.setCookie('userStore',  storeParam);
                this.setCookie('userRegion', '', -1);
            } else {
                this.setCookie('userRegion', regionParam);
                this.setCookie('userStore',  '', -1);
            }

            const storeKey = this.getCookie('userStore') || this.getCookie('userRegion');
            const store    = this.findStoreByKey(storeKey);
            if (!store.id) {

                if (this.savedStore.id) {
                    this.visiblePopupPreviewStore(true);
                    this.setErrorLocator('ok',
                        `We couldn't find the store you linked, but we have a previous store – “${this.savedStore.location_title}”. Stay there?`
                    );
                } else {
                    this.visiblePopupLocator(true);
                    this.setErrorLocator('error',
                        `Store “${storeKey}” not found. Please choose another.`
                    );
                }
                return;
            }

            const isSameStore = store.id === this.savedStore?.id;
            this.selectStore(store);
            this.saveStore();

            urlParams.delete('store');
            urlParams.delete('region_id');
            const cleanURL = urlParams.toString()
                ? `${location.pathname}?${urlParams}` : location.pathname;

            const isPdp = location.pathname.includes('/products/');
            if (isSameStore || window.__storeReloadScheduled || !isPdp) {

                history.replaceState(null, '', cleanURL);
                this.visiblePopupLocator(false);
                return;
            }

            window.__storeReloadScheduled = true;
            sessionStorage.setItem('storeReloadInProgress', '1');
            // location.replace(cleanURL);
            history.replaceState(null, '', cleanURL);
            this.visiblePopupLocator(false);
        },

        clearPredictions() {
            this.predictions = [];
        },

        setPredictions(payload) {
            this.predictions = payload;
        },

        clearSearchQuery() {
            this.query = "";
        },

        setSearchQuery(payload) {
            this.query = payload;
        },

        clearSelectedStore() {
            this.selectedStore = {};
        },

        setSelectedStore(payload) {
            this.selectedStore = payload;
        },

        clearSavedStore() {
            this.savedStore = {};
        },

        setSavedStore(storeID) {
            this.savedStore = this.findStoreById(storeID);

            window.OD.store = {
                ...this.savedStore
            };

            setTimeout(() => {
                this.initStoreOnSearchORCollection();
            }, 1000);

            this.initStoreOnPDP();

            this.stores = this.stores.map((store, index) => {
                return {
                    ...store,
                    isVisible:
                        this.savedStore.location_state ===
                            store.location_state ||
                        this.savedStore.id === store.id
                };
            });

            this.initSaleCollectionLink();
            console.log("saved store init", this.savedStore);

            this.panToSavedStore();
        },

        panToSavedStore() {
            if (
                !this.savedStore ||
                !this.savedStore.location_address ||
                !this.map.init
            ) {
                return;
            }

            const geocoder = new google.maps.Geocoder();
            geocoder.geocode(
                { address: this.savedStore.location_address },
                (results, status) => {
                    if (status === "OK") {
                        const position = results[0].geometry.location;

                        this.map.init.setZoom(15);
                        this.map.init.panTo(position);
                    } else {
                        console.error(
                            `Geocode failed for saved store: ${status}`
                        );
                    }
                }
            );
        },

        chooseNewStore() {
            this.visiblePopupPreviewStore(false);
            this.visiblePopupLocator(true);
        },

        fetchPredictions() {
            if (this.stores.length === 0) {
                this.clearPredictions();
                this.setErrorLocator("error", "Sorry, no stores were found.");
                return;
            }

            if (this.query.trim() === "") {
                this.clearPredictions();
                this.setErrorLocator(
                    "warning",
                    "Please enter at least 1 character."
                );
                return;
            }

            const options = {
                input: this.query,
                types: ["(regions)"],
                componentRestrictions: { country: ["au", "nz"] }
            };

            this.googleAutocompleteService.getPlacePredictions(
                options,
                (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        const filteredResults = results.filter((prediction) => {
                            return !prediction.description.match(
                                /^(Australia|New Zealand)$/
                            );
                        });
                        if (filteredResults.length == 1 && !isNaN(this.query)) {
                            const pcpos = filteredResults[0].description.indexOf(this.query)
                            const statePos = filteredResults[0].description.substring(0,pcpos).trim().lastIndexOf(' ')
                            filteredResults[0].description = filteredResults[0].description.substring(statePos)
                        }
                        this.setPredictions(filteredResults);
                    } else {
                        this.clearPredictions();
                        this.setErrorLocator(
                            "error",
                            `No stores found for "${this.query}".`
                        );
                    }
                }
            );

            const container = document.querySelector(
                ".store-locator-popup .locations-group"
            );
            container && window.OD.checkScrollVisibility(container);
        },

        getPlaceDetails(placeId) {
            const service = new google.maps.places.PlacesService(
                document.createElement("div")
            );

            service.getDetails({ placeId: placeId }, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    const state = place.address_components.find((component) =>
                        component.types.includes("administrative_area_level_1")
                    );

                    if (state) {
                        this.predictionState = state;
                    } else {
                        this.predictionState = {};
                    }
                }
            });
        },

        selectPrediction(prediction, isStorePage) {
            const placeId = prediction.place_id;
            this.getPlaceDetails(placeId);

            this.setSearchQuery(prediction.description);

            this.clearPredictions();
            this.clearErrorLocator();

            if (isStorePage) {
                this.getStoresWithDistance();
            }
        },

        chunkArrayForDistance(array, size) {
            const chunks = [];
            for (let i = 0; i < array.length; i += size) {
                chunks.push(array.slice(i, i + size));
            }
            return chunks;
        },

        async getStoresWithDistance() {
            const queryLowercase = this.query.toLowerCase();
            if (
                !queryLowercase.includes("australia") &&
                !queryLowercase.includes("new zealand")
            ) {
                console.log("Neither 'Australia' nor 'New Zealand' found.");
                if (queryLowercase.includes("zealand")) {
                    this.setSearchQuery(`${this.query}, New Zealand`);
                    console.log("Adding New Zealand to search query");
                } else {
                    this.setSearchQuery(`${this.query}, Australia`);
                    console.log("Adding Australia to search query");
                }
            } else {
                console.log("Either 'Australia' or 'New Zealand' is present.");
            }

            const storeLocations = this.stores.map((el) => el.location_address);
            const locationChunks = this.chunkArrayForDistance(
                storeLocations,
                25
            );

            const allResults = [];

            for (const chunk of locationChunks) {
                const requestToGetDistance = {
                    origins: [this.query],
                    destinations: chunk,
                    travelMode: google.maps.TravelMode.DRIVING,
                    unitSystem: google.maps.UnitSystem.METRIC,
                    avoidHighways: false,
                    avoidTolls: false
                };

                try {
                    const response =
                        await this.googleDistanceService.getDistanceMatrix(
                            requestToGetDistance
                        );
                    allResults.push(...response.rows[0].elements);
                } catch (error) {
                    console.error("Error fetching store distances:", error);
                    return;
                }
            }

            this.stores = this.stores.map((store, index) => {
                const distanceData = allResults[index];

                if (
                    distanceData &&
                    distanceData.status === "OK" &&
                    distanceData.distance
                ) {
                    return {
                        ...store,
                        googleDistance: {
                            text: distanceData.distance.text,
                            value: distanceData.distance.value
                        },
                        googleDuration: {
                            text: distanceData.duration.text,
                            value: distanceData.duration.value
                        },
                        googleState: {
                            ...this.predictionState
                        },
                        isVisible:
                            this.predictionState.short_name ===
                                store.location_state ||
                            this.savedStore.id === store.id
                    };
                }
                return {
                    ...store,
                    googleDistance: null,
                    googleDuration: null,
                    googleState: {
                        ...this.predictionState
                    },
                    isVisible:
                        this.predictionState.short_name ===
                            store.location_state ||
                        this.savedStore.id === store.id
                };
            });

            this.stores.sort((a, b) => {
                const distanceA = a.googleDistance?.value ?? Infinity;
                const distanceB = b.googleDistance?.value ?? Infinity;
                return distanceA - distanceB;
            });

            this.visibleStoreList(true);
            this.clearSearchQuery();

            this.map.init && this.triggerStoresMap();
        },

        isStoreAvailableForProduct(normalizedStoreName) {
            return this.pdpLocationAvailability?.some((location) =>
                normalizedStoreName
                    .toLowerCase()
                    .includes(location.toLowerCase())
            );
        },
        isStoreMatchingLocation() {
            return this.stores.filter((store) =>
                this.pdpLocationAvailability.some((location) =>
                    store.location_title
                        .toLowerCase()
                        .includes(location.toLowerCase())
                )
            );
        },

        get filteredStores() {
            if (this.pdpLocationAvailability.length > 0) {
                return this.isStoreMatchingLocation();
            }
            return this.stores;
        },

        findStoreByKey(storeKey) {
            storeKey = decodeURIComponent(storeKey).toLowerCase();
            const storeHandleFormatted = storeKey
                .replace(/[\s_]+/g, "-")
                .replace(/[^a-z0-9-]/g, "")
                .replace(/-+/g, "-")
                .replace(/^-|-$/g, "");
            console.log(this.stores);
            console.log(
                this.stores.find(
                    (store) =>
                        store.location_title.toLowerCase() === storeKey ||
                        store.store_handle.toLowerCase() ===
                            storeHandleFormatted ||
                        store.gmc_code == storeKey ||
                        store.region_id == storeKey ||
                        store.id == storeKey
                ) || {}
            );
            return (
                this.stores.find(
                    (store) =>
                        store.location_title.toLowerCase() === storeKey ||
                        store.store_handle.toLowerCase() ===
                            storeHandleFormatted ||
                        store.gmc_code == storeKey ||
                        store.region_id == storeKey ||
                        store.id == storeKey
                ) || {}
            );
        },

        findStoreById(storeId) {
            return this.stores.find((store) => store.id === storeId) || {};
        },

        selectStore(store, selectStore) {
            const { id, name } = store;
            this.setSelectedStore({ id, name });

            if (store && this.map.init) {
                this.panToMarker(store);
            }

            if (selectStore) {
                this.saveStore();
            }
        },

        async saveStore() {
            await this.fetchCart();
            if (this.isCartEmpty) {
                localStorage.setItem(
                    "selectedStore",
                    JSON.stringify(this.selectedStore)
                );

                this.visiblePopupLocator(false);
                this.setSavedStore(this.selectedStore.id);

                console.log("save store");
            } else {
                this.visiblePopupLocator(false);
                this.visiblePopupClearCart(true);
                console.log("cart not empty");
            }

        }
    };
}
